module.exports = __webpack_public_path__ + "img/chat-input-video.26856eec.svg";